<template>
  <a-tabs v-model="doingViewKey"  >
    <a-tab-pane  key="1" tab="受试者表单" >

      <a-card>
        <check-list ref="check-list" :base-query="{voiceChecked:'0'}" :batch="true"  @handleSearch="handleSearch">
        <span slot="btn">
          <a-button style="margin-left: 20px" @click="startVoiceCheck">开始语音核查</a-button>
        </span>
        </check-list>
        <a-modal
          title="选择模型"
          :width="800"
          :visible="startVoiceCheckVisible"
          :footer="null"
          @cancel="startVoiceCheckVisible = false">
          <a-row>
            <a-col :span="6">
              抽查类型：
            </a-col>
            <a-col :span="16">
              <a-radio-group v-model="startVoiceForm.type" >
                <a-radio-button value="0">
                  全部抽查
                </a-radio-button>
                <a-radio-button value="1">
                  随机抽查
                </a-radio-button>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row v-if="startVoiceForm.type == '1'" style="margin-top: 20px">
            <a-col :span="6">
              抽查数量：
            </a-col>
            <a-col :span="16">
              <a-input-number v-model="startVoiceForm.num" placeholder="请输入" :min="0" :precision="0" style="width: 100%"/>
            </a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="6">
              通过率：
            </a-col>
            <a-col :span="16">
              <a-input-number v-model="startVoiceForm.voicePassRate" placeholder="请输入" :min="0" :precision="0" style="width: 90%"/>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="6">
            </a-col>
            <a-col :span="16" class="tip">
              通过率是每个受试者单个表单的通过率，即每个表单的题目通过率（题目通过数量/题目总数量）来标记表单是否通过。
            </a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="6">
              通过规则：
            </a-col>
            <a-col :span="16">
              <a-radio-group v-model="startVoiceForm.passRule" size="small">
                <a-radio-button value="1">
                  任意通过一个视为通过
                </a-radio-button>
                <a-radio-button value="2">
                  必须所有通过才视为通过
                </a-radio-button>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="6">
              语音模型：
            </a-col>
            <a-col :span="16">
              <a-checkbox-group v-model="startVoiceForm.modelIdList" >
                <a-checkbox v-for="(item, index) in modelList" :key="index" :value="item.id">{{ item.name }}</a-checkbox>
              </a-checkbox-group>
            </a-col>
          </a-row>
          <div style="text-align: right">
            <a-button type="primary" @click="startVoiceCheckSubmit">开始核查</a-button>
          </div>

        </a-modal>
      </a-card>
    </a-tab-pane>
    <a-tab-pane  key="2" tab="核查进度" >
      <a-card>
        <voice-doing ref="voice-doing"  ></voice-doing>
      </a-card>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  import { getAction ,postAction} from '@/api/manage'
  import CheckList from './check/CheckList'
  import VoiceDoing from './voice/VoiceDoing'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'VoicePatient',
    components: { VoiceDoing, CheckList },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        doing:false,
        doingViewKey:'1',
        selectRowKeys:[],
        startVoiceCheckVisible:false,
        startVoiceForm:{
          type:'0',
          voicePassRate:80,
          num:100,
          modelIdList:[],
          passRule:'1',
        },
        modelList:[],

      }
    },

    mounted(){
      const voiceApplyId = this.$route.query.voiceApplyId
      if(voiceApplyId){
        this.doingViewKey = '2'
        this.$nextTick(()=>{
          this.$refs['voice-doing'].start(voiceApplyId)
        })
      }
      getAction('/project/voiceConfig/listAll',{projectId:this.projectId,enabled:'1'}).then(res=>{
        if(res.success){
          this.modelList = res.result
        }
      })
    },
    methods:{
      handleSearch(){},
      startVoiceCheck(){
        const dataLength = this.$refs['check-list'].dataSource.length
        if(dataLength<=0){
          return this.$message.warning('当前无查询结果')
        }
        this.startVoiceCheckVisible = true
      },
      startVoiceCheckSubmit(){
        if(this.startVoiceForm.type=='1' && this.startVoiceForm.num<=0){
          return this.$message.warning('请选择数量')
        }
        if(this.startVoiceForm.modelIdList.length==0){
          return this.$message.warning('请选择语音模型')
        }
        if(!this.startVoiceForm.passRule){
          return this.$message.warning('请选择通过规则')
        }
        const  searchParams = this.$refs['check-list'].getQueryParams()
        const params = Object.assign(searchParams,this.startVoiceForm)
        const modelList = []
        this.modelList.forEach(model=>{
          params.modelIdList.forEach(id=>{
            if(id===model.id){
              modelList.push({
                code:model.code,
                weight:model.priority,
              })
            }
          })
        })
        delete params.modelIdList
        params.models = JSON.stringify(modelList)
        postAction('/patient/patientVoice/createRandom',params).then(res=>{
          if(res.success){
            this.$refs['check-list'].loadData()
            this.doingViewKey = '2'
            this.startVoiceCheckVisible = false
            this.$nextTick(()=>{
              this.$refs['voice-doing'].start(res.result.id)
            })
          }else{
            this.$message.error(res.message)
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .tip{
    color: rgba(0,0,0,0.4);
  }
</style>